export const EXTERNAL_PORTALS = {
  memberLoginUrl:
    '/auth/login',
  memberCenterUrl:
    'https://login.sun-bd.com/#/profile',
  paymentUrl:
    import.meta.env.VITE_EXTERNAL_PAYMENT_URL || 'https://www.sun-bd.com/payment.html',
  memberApiDocsUrl:
    'https://login.sun-bd.com/docs/integration/sso.html',
  paymentApiDocsUrl:
    'https://pay.sun-bd.com/docs/payment-points-api.html',
} as const;

export function currentReturnUrl(): string {
  return `${window.location.origin}${window.location.pathname}${window.location.search}${window.location.hash}`;
}

export function withCrmReturnUrl(targetUrl: string, returnUrl = currentReturnUrl()): string {
  try {
    const url = new URL(targetUrl, window.location.origin);
    if (url.origin === window.location.origin && url.pathname === '/auth/login') {
      const candidate = new URL(returnUrl, window.location.origin);
      const safePath = candidate.origin === window.location.origin
        && candidate.pathname.startsWith('/')
        && !candidate.pathname.startsWith('//')
        && !candidate.pathname.startsWith('/auth/')
        && candidate.pathname !== '/login'
        ? candidate.pathname + candidate.search + candidate.hash
        : '/';
      url.searchParams.set('returnPath', safePath);
    } else {
      url.searchParams.set('returnUrl', returnUrl);
      url.searchParams.set('source', 'wems-crm');
    }
    return url.toString();
  } catch {
    return targetUrl;
  }
}

export function getExternalMemberLoginUrl(returnUrl?: string): string {
  return withCrmReturnUrl(EXTERNAL_PORTALS.memberLoginUrl, returnUrl);
}

export function getExternalPaymentUrl(returnUrl?: string): string {
  return withCrmReturnUrl(EXTERNAL_PORTALS.paymentUrl, returnUrl);
}
